export enum ProcessingFacilityTableProps {
  PROCESSING_FACILITY_TITLE = 'Processing Facility',
  PROCESSING_FACILITY_INDEX = 'name',
  PROCESSING_FACILITY_SORT_ORDER = 'descend',
  SCOPE_TILE = '<p>Scope 1 (tonnes CO<sub>2</sub>e)</p>',
  SCOPE1_TITLE1 = 'Scope 1 (tonnes CO\u2082e)',
  SCOPE1_INDEX = 'scope1',
  SCOPE1_SORT_ORDER = 'descend',
  SCOPE2_TITLE1 = 'Scope 2 (tonnes CO\u2082e)',
  SCOPE2_INDEX = 'scope2',
  SCOPE2_SORT_ORDER = 'descend',
  TOTAL_TITLE1 = 'Total (tonnes CO\u2082e)',
  TOTAL_TITLE = 'Total (tonnes CO2e)',
  TOTAL_INDEX = 'total',
  TOTAL_SORT_ORDER = 'descend',
  ACTION_TITLE = '',
  ACTION_INDEX = 'actions',
  ACTION_WIDTH = '10%',
  DELETE_HEADING = 'Do you want to delete this Facility?',
  SUB_HEADING = 'By deleting this Processing Facility, it will be permanently removed and you will not be to retrieve it later.',
}

export enum ProcessingFacilityProps {
  LOADING_INDICATOR = 'Loading...',
  DELETE_ICON_ALT = 'delete',
  EDIT_ICON_ALT = 'edit',
}

export enum MockData {
  PROCESSING_FACILITY = 'Processing Facility',
}

export enum ProcessingFacilityFieldEnums {
  TOTAL_PERIOD_UNITS_NAME = "totalPeriodUnits",
  TOTAL_PERIOD_UNITS_PLACEHOLDER = "Reporting Period Production (units)",
  PROCESSING_FACILITY_TOTAL_NAME = "processingFacilityTotal",
  PROCESSING_FACILITY_TOTAL_PLACEHOLDER = "Total goods transported",
  TOTAL_UNIT_NAME = "totalUnit",
  TOTAL_UNIT_PLACEHOLDER = "Goods stored or sold in processing facility",
  TOTAL_UNIT_LABEL = "Goods in processing facility",
  ONLINE_RETAIL_NAME = "onlineRetail",
  ONLINE_RETAIL_PLACEHOLDER = "Goods sold via online retail",
  END_MARKET_LOCATION_NAME = "endMarketLocation",
  END_MARKET_LOCATION_PLACEHOLDER = "End Market Location",
  UNITS_NAME = "units",
  UNITS_PLACEHOLDER = "Quantity of goods sent to this location",
  TRANSPORTATION_AIR_NAME = "transportationAir",
  TRANSPORTATION_AIR_PLACEHOLDER = "Check this box if transportation is via air",
  ADDRESS = "address"
}
